import {
    Button,
    Modal,
    TextField,
    InputAdornment
} from "@mui/material";
import { React, useState, useContext, useEffect } from 'react'
import { Context } from './ListadoTasasScreen'
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValTasaInteres } from "./ValTasaInteres";

const ModalTasasScreen = ({ updatedata, idtasa, onClose }) => {
    const { state, setState } = useContext(Context);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    //datos a guardar
    const [intereses, setIntereses] = useState({
        idtipo_tasa: -999,
        descripcion: "",
        fecha_inicio: "",
        fecha_fin: "",
        documento: "",
        extension: "",
        bdescripcion: false,
    });
    const [registro, setRegistro] = useState(0)

    const closeModal = () => {
        setIntereses({
            ...intereses,
            idtipo_tasa: -999,
            descripcion: "",
            fecha_inicio: "",
            fecha_fin: "",
            documento: "",
            extension: "",
            bdescripcion: false,
        })
        
        setState({
            ...state,
            open: false,
        });
        onClose()
    };

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setIntereses({
            ...intereses,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    const Editar = () => {

        if (idtasa !== null || idtasa !== "" || idtasa !== -999 || idtasa !== undefined) {
            request
                .get(`FTasaInteres/BuscarID?idtipo_tasa=${idtasa}`)
                .then((result) => {
                    setIntereses({
                        ...intereses,
                        idtipo_tasa: result.idtipo_tasa,
                        descripcion: result.descripcion,
                        fecha_inicio: result.fecha_inicio.substring(0, 10),
                        fecha_fin: result.fecha_fin.substring(0, 10),
                    });
                })
                .catch((error) => {
                    Swal.fire("INTERESES", JSON.stringify(error), "error");
                });

        } else {
            return;
        }
    }
    console.log(intereses)
    useEffect(() => {

        if (idtasa !== undefined && idtasa !== null && Number(idtasa) > 0) {
            Editar();
        } else {
            setIntereses({
                ...intereses,
                idtipo_tasa: -999,
                descripcion: "",
                fecha_inicio: "",
                fecha_fin: "",
                documento: "",
                extension: "",
                bdescripcion: false,
            })
        }
    }, [updatedata]);


    const onGuardar = () => {

        var result = ValTasaInteres(intereses);
        if (result.isValid === false) {
            Swal.fire(
                "TASA DE INTERESES",
                JSON.stringify(result.mensaje),
                "error"
            );
            return;
        }
        else if (intereses.documento === null || intereses.documento === "" || intereses.documento === 0) {
            Swal.fire({
                title: "TASA DE INTERESES",
                text: "Favor de cargar documento antes de guardar",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        else {
            result.post.idtipo_tasa = intereses.idtipo_tasa;
            result.post.fecha_inicio = intereses.fecha_inicio;
            result.post.fecha_fin = intereses.fecha_fin;
            result.post.documento = intereses.documento;
            result.post.extension = intereses.extension;

            if (intereses.fecha_inicio === null || intereses.fecha_inicio === 0 || intereses.fecha_inicio === "" || intereses.fecha_fin === null || intereses.fecha_fin === 0 || intereses.fecha_fin === "") {
                Swal.fire({
                    title: 'TASA DE INTERESES',
                    text: 'LAS FECHAS DE INICIO Y TERMINO SON OBLIGATORIAS',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                });
            }
            else {
                if (intereses.fecha_inicio >= intereses.fecha_fin) {
                    Swal.fire({
                        title: 'TASA DE INTERESES',
                        text: 'LA FECHA DE INICIO NO PUEDE SER MAYOR A LA DE TERMINO',
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                    });
                }
                else {
                    request
                        .post("FTasaInteres", result.post)
                        .then(async () => {
                            setLoader({ ...loader, mostrar: false });
                            updatedata()
                            await Swal.fire({
                                title: "TASA DE INTERESES",
                                text: "Registro guardado con éxito",
                                icon: "success",
                                customClass: {
                                    container: "mi-superpoop",
                                },
                            });
                            closeModal();
                        })
                        .catch((error) => {
                            setLoader({ ...loader, mostrar: false });
                            Swal.fire("DOCUMENTOS", JSON.stringify(error), "error");
                        });
                }
            }

        }
    };

    const GetFile = ({ target }) => {

        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("TASA INTERES JDF", "Archivo invalido", "error");
            return;
        }

        if (
            file[1] !== "jpg" &&
            file[1] !== "jepg" &&
            file[1] !== "pdf" &&
            file[1] !== "PDF"
        ) {
            Swal.fire("TASA INTERES JDF", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }

        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setIntereses({
                ...intereses,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };
    return (
        <Modal open={state.open}>
            <div className="dash-clientes-credito-crear-solicitud-modal">
                <div className="credito-agregar-modal-title">
                    {/* <Agriculture
              color="primary"
              style={{ textAlign: "center", fontSize: 50 }}
            /> */}
                    <div className="filtro-soy-el-titulo-header">
                        <h3>AGREGAR DESCRIPCION DE INTERES </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div>
                        <TextField
                            id="clientes-documento"
                            label="Descripción"
                            type="text"
                            value={intereses.descripcion}
                            onChange={({ target }) => {
                                setIntereses({
                                    ...intereses,

                                    descripcion: target.value,
                                    bdocumento: false,
                                });
                            }}
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                    <div className="tasa-intereses-modal-inputs-fechas-container">
                        <TextField
                            fullWidth
                            label="Fecha de Inicio"
                            size="small"
                            color="success"
                            type="date"
                            className="w-66"
                            value={intereses.fecha_inicio}
                            onChange={({ target }) =>
                                setIntereses({ ...intereses, fecha_inicio: target.value })
                            }
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {/* <BusinessIcon /> */}
                                    </InputAdornment>
                                ),
                            }}
                            inputProps={{
                                maxLength: 100,
                            }}
                            sx={{
                                mt: 2,
                            }}
                        />

                        <TextField
                            fullWidth
                            label="Fecha de Término"
                            size="small"
                            color="success"
                            type="date"
                            className="w-66"
                            value={intereses.fecha_fin}
                            onChange={({ target }) =>
                                setIntereses({ ...intereses, fecha_fin: target.value })
                            }
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {/* <BusinessIcon /> */}
                                    </InputAdornment>
                                ),
                            }}
                            inputProps={{
                                maxLength: 100,
                            }}
                            sx={{
                                mt: 2,
                            }}
                        />
                    </div>
                    <div className="">

                        <TextField
                            id="clientes-documento"
                            type="file"
                            onChange={GetFile}
                            sx={{ mb: 2, width: 540 }}
                        />

                    </div>

                </div>

                <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={closeModal} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalTasasScreen
